



















import {Component, Mixins, Prop} from 'vue-property-decorator'
import ItemCard from '@/components/card/ItemCard.vue'
import toCurrency from '@/filters/to-currency'
import toDate from '@/filters/to-date'
import toStatusColor from '@/filters/to-invoice-status-color'
import toStatusTextColor from '@/filters/to-invoice-status-text-color'
import Translation from '@/mixins/Translation'
import {Status} from '@/store/modules/invoices/modules/issued/types'

@Component({
  components: {
    ItemCard,
  },
})
export default class InvoiceIssueCard extends Mixins(Translation) {
  @Prop({default: 'terms', type: String}) translation: string
  @Prop({default: 0, type: Number}) totalAmount: number
  @Prop({default: 0, type: Number}) tradedAt: number
  @Prop({default: '', type: String}) id: string
  @Prop({default: '', type: String}) status: Status
  @Prop({default: '', type: String}) mainItemName: string
  @Prop({default: '', type: String}) rawDataClientName: string
  @Prop({default: '', type: String}) clientBizNumber: string
  @Prop({default: false, type: Boolean}) loading: boolean
  @Prop({default: false, type: Boolean}) disabled: boolean

  get actions() {
    return [
      {
        title: toDate(this.tradedAt),
        color: 'gray-600',
        size: 'mini',
      },
      {
        title: toCurrency(this.totalAmount) + this.ts('currency'),
        color: this.totalAmount < 0 ? 'danger-light-2' : 'gray-800'
      }
    ]
  }

  get invoiceCardTitle() {
    return this.rawDataClientName || this.clientBizNumber || ' '
  }

  get tags() {
    const {status} = this
    return [{
      name: this.ts(`invoice-issued-status.${status}`),
      color: toStatusColor(status),
      textColor: toStatusTextColor(status),
    }]
  }
}
